<div class="sticky-toolbar mb-8  text-[14px]">
  <p-toolbar class="text-[14px] p-0">
        <ng-template #start>
            <p-button label="New" icon="pi pi-plus" severity="secondary" class="mr-2" (onClick)="New()" />
        </ng-template>

        <ng-template #end>
        </ng-template>
    </p-toolbar>
</div> 

<p-table
    #dt
    [value]="teams"
    [rows]="20"
    [paginator]="true"
    [contextMenu]="cm"
    (onContextMenuSelect)="onRowSelect($event)"
    [(selection)]="selectedTeams"
    [tableStyle]="{ 'min-width': '75rem' }"
    [rowHover]="true"
    dataKey="id"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} teams"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[20, 40, 60, 100]"
    [globalFilterFields]="['teamName', 'teamLead', 'membersCount', 'project']"
>
    <ng-template #caption>
        <div class="flex items-center justify-between">
            <h5 class="m-0">Manage Teams</h5>
            <p-iconfield>
                <p-inputicon styleClass="pi pi-search" />
                <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Search..." />
            </p-iconfield>
        </div>
    </ng-template>

    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="teamName">Team Name <p-sortIcon field="teamName" /></th>
            <th pSortableColumn="teamLead">Team Lead <p-sortIcon field="teamLead" /></th>
            <th pSortableColumn="membersCount">Members Count <p-sortIcon field="membersCount" /></th>
            <th pSortableColumn="project">Project <p-sortIcon field="project" /></th>
            <th>Actions</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-team>
        <tr [pSelectableRow]="team" (contextmenu)="onRightClick($event, team)">
            <td style="width: rem">
                <p-tableCheckbox [value]="team" />
            </td>
            <td>
              <a (click)="openTeamDetails(team)" class="text-blue-600 hover:underline">
                {{ team.teamName }}
              </a>
            </td>
            <td>{{ team.teamLead }}</td>
            <td>{{ team.membersCount }}</td>
            <td>{{ team.project }}</td>
            <td>
                <p-button label="" icon="pi pi-fw pi-user-edit" class="mr-2" [outlined]="true" (onClick)="editTeam(team)" />
                <p-button label="" icon="pi pi-trash" severity="danger" [outlined]="true" (onClick)="deleteTeam(team)" />
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [(visible)]="isCreatingNewTeam" [style]="{ width: '450px' }" header="Create New Team" [modal]="true">
  <ng-template #content>
    <!-- Team Name -->
    <div class="field mb-4">
      <label for="teamName" class="block font-bold mb-3">Team Name</label>
      <input
        type="text"
        id="teamName"
        [(ngModel)]="newTeam.teamName"
        required
        class="border p-2 w-full"
        #teamNameField
        (keydown.enter)="teamLeadField.focus()"
      />
      <small class="text-red-500" *ngIf="submitted && !newTeam.teamName">Team Name is required.</small>
    </div>

    <!-- Team Lead -->
    <div class="field mb-4">
      <label for="teamLead" class="block font-bold mb-3">Team Lead</label>
      <input
        type="text"
        id="teamLead"
        [(ngModel)]="newTeam.teamLead"
        required
        class="border p-2 w-full"
        #teamLeadField
        (keydown.enter)="projectField.focus()"
      />
      <small class="text-red-500" *ngIf="submitted && !newTeam.teamLead">Team Lead is required.</small>
    </div>

    <!-- Project -->
    <div class="field mb-4">
      <label for="project" class="block font-bold mb-3">Project</label>
      <input
        type="text"
        id="project"
        [(ngModel)]="newTeam.project"
        required
        class="border p-2 w-full"
        #projectField
        (keydown.enter)="teamMembersField.nativeElement.focus()"
      />
      <small class="text-red-500" *ngIf="submitted && !newTeam.project">Project is required.</small>
    </div>

    <!-- Team Members -->
    <div class="field mb-4">
      <label for="teamMembers" class="block font-bold mb-3">Team Members</label>
      <p-multiSelect
        id="teamMembers"
        [(ngModel)]="newTeam.members"
        [options]="availableMembers"
        defaultLabel="Select team members"
        [style]="{ width: '100%' }"
      ></p-multiSelect>
      <small class="text-red-500" *ngIf="submitted && (!newTeam.members || newTeam.members.length === 0)">Team Members are required.</small>
    </div>
  </ng-template>

  <ng-template #footer>
    <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
    <p-button label="Save" icon="pi pi-check" (click)="saveNewTeam()" />
  </ng-template>
</p-dialog>

